const Colors = {
    PlaceHolder: (opacity = '0.5') => `rgba(235, 235, 235, ${opacity})`,
    BlackOpacity: (opacity = '0.5') => `rgba(0, 0, 0, ${opacity})`,
    WhiteOpacity: (opacity = '0.5') => `rgba(255, 255, 255, ${opacity})`,
    Black: '#000000',
    LightBlack: '#2F3032',
    Transparent: 'transparent',
    Primary: '#0BD194',
    Secondary: '#000000',
    DarkGray: '#1E1E22',
    LightGray: '#F3F6FF',
    White: '#ffffff',
    Text: '#ffffff',
    Danger: '#FF494C',
    Yellow: '#EEB600',
    LabelColor: '#4E5D78',
    Gray: '#9A99A9',
    Error: 'red',
    MenuItem: '#A2A9B8',
};
export const statusColors = {
    cancelled: '#E71D36',
    'Pending Acceptance': '#EEB600',
    Accepted: '#2B9943',
};

export const DEFAULT_USER_COLORS = {
    primaryColour: '#0BD194',
    // primary: 'red',
    secondaryColour: '#FFA800',
    textColour: '#01003B',
};

export default Colors;
